import { render } from "./NotificationDimensions.vue?vue&type=template&id=4d105f51&scoped=true&ts=true"
import script from "./NotificationDimensions.vue?vue&type=script&lang=ts"
export * from "./NotificationDimensions.vue?vue&type=script&lang=ts"

import "./NotificationDimensions.vue?vue&type=style&index=0&id=4d105f51&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d105f51"]])

export default __exports__